<template>
  <mock-up-main>
    <div v-if="loading" class="fill-height d-flex align-center justify-center white"
         style="position: absolute; inset: 0; z-index: 10;">
      <v-progress-circular color="primary" height="5" indeterminate/>
    </div>
            <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کیوآر منو'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

    <intro-slider v-if="value" v-model="computedBanner" :is-slider="false"/>

    <v-card v-if="!!value && !!value.product"
            :style="{color: !!value.product.sectionColor ? value.product.sectionColor.text : '',
             background: !!value.product.sectionColor ? value.product.sectionColor.backGround : ''}"
            class="rounded-0" flat>
      
      <v-card-title v-show="!!menuSettings.sectionTitle" class="text-center justify-center">
        {{ menuSettings.sectionTitle }}
      </v-card-title>
      
      <p v-show="!!value.product.description" class="text-center">{{ value.product.description }}</p>
      <component :is="MCategoryViews[theme]"         
        v-model="selectedCategory" 
        :filters.sync="categoryFilter" 
        :items="value.product.items"
        :show-filter="menuSettings.showFilter"
        v-if="menuSettings.showCategories"
      />
      <!-- <m-category-view 
        v-model="selectedCategory" 
        :filters.sync="categoryFilter" 
        :items="value.product.items"
        :show-filter="menuSettings.showFilter"
        v-if="menuSettings.showCategories"
      /> -->

      <div v-if="!!value.product && !!value.product.items[selectedCategory]" class="pa-2">
        <div v-for="(product, i) in getProductList" :key="i" class="rounded-lg mb-3">
          <component :is="MProductCards[theme]"   :value="product"
            :currencySymbol="menuSettings.currency"
            :cart-button-text="menuSettings.cartButtonText"/>
        </div>
      </div>
    </v-card>

    <ads-components
      v-else-if="!!value.product && !!value.product.items && value.product.items.length > 0" v-model="value.product"/>

    <gallery-slider
      v-if="value.PicSelector && hasGallery && value.PicSelector.slider" v-model="value.gallery"
      :description="value.PicSelector.description"
      :style="{'background':value.PicSelector.sectionColor.backGround, 'color':value.PicSelector.sectionColor.text}"
      :title="value.PicSelector.title"/>

    <b-gallery-view
      v-else-if="value && value.PicSelector" v-model="value.gallery" :description="value.PicSelector.description"
      :is-img="true"
      :style="{ background: value.PicSelector.sectionColor.backGround, color: value.PicSelector.sectionColor.text, }"
      :title="value.PicSelector.title"
    />

    <b-gallery-view
      v-if="hasVideo" v-model="value.video_gallery" :description="value.VideoGallery.description" :is-img="false"
      :style="{ background: value.VideoGallery.sectionColor.backGround, color: value.VideoGallery.sectionColor.text }"
      :title="value.VideoGallery.title"
      type="video_gallery"/>

    <b-feedback-view
      v-if="value.FeedBack && value.FeedBack.items.length > 0" v-model="value.FeedBack"/>

    <b-footer-view v-if="value.textCards" v-model="value"
                   :style="{'background' : value.textCards.sectionColor.backGround, 'color' : value.textCards.sectionColor.text}"
                   class="mt-10"/>
  </mock-up-main>
</template>

<script>
import MockUpMain from "@/view/pages/businessPage/components/mockUp";
import IntroSlider from "@/view/pages/businessPage/components/view/bIntroSliderView";
import MCategoryView from "@/view/pages/otherQrTypes/menu/cm/mCategoryView";
import MCategoryView2 from "@/view/pages/otherQrTypes/menu/cm/mCategoryView2";
import MCategoryView3 from "@/view/pages/otherQrTypes/menu/cm/mCategoryView3";
import AdsComponents from "@/view/components/Product/AdsComponents";
import BFooterView from "@/view/pages/businessPage/components/view/bFooterView";
import GallerySlider from "@/view/pages/businessPage/components/view/gallerySlider";
import BGalleryView from "@/view/pages/businessPage/components/view/bGalleryViewNew.vue";
import BFeedbackView from "@/view/pages/businessPage/components/view/bFeedbackView";
import MProductCard from "@/view/components/Product/mProductCard.vue";
import MProductCard2 from "@/view/components/Product/mProductCard2.vue";
import MProductCard3 from "@/view/components/Product/mProductCard3.vue";
import MProductCard4 from "@/view/components/Product/mProductCard4.vue";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "viewMenu",

  components: {
    MProductCard,
    BFeedbackView,
    BGalleryView, GallerySlider, BFooterView, AdsComponents, MCategoryView, IntroSlider, MockUpMain,
    MCategoryView2, MProductCard2, MCategoryView3, MProductCard3, MProductCard4,UniversalQrModal

  },

  props: {
    value: Object,
    loading: Boolean,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    showQrDialog:false,
    MProductCards:{
      'theme_1':'MProductCard',
      'theme_2':'MProductCard2',
      'theme_3':'MProductCard3',
      'theme_4':'MProductCard4'
    },
    MCategoryViews:{
      'theme_1':'MCategoryView',
      'theme_2':'MCategoryView2',
      'theme_3':'MCategoryView3',
      'theme_4':'MCategoryView3',
      
     } ,
    selectedCategory: 0,
    categoryFilter: {
      sub: null
    }
  }),

  computed: {
    theme(){
      return this.value?.ThemeSelector2?.theme ||'theme_1';
    },
        menuSettings() {
      const rawSettings = (this.value && this.value.settings) ? this.value.settings : {};
      const customLabels = rawSettings.customLabels || {};
      
      const businessType = rawSettings.businessType || 'restaurant';

      const titleKeys = {
        cafe: 'settings.custom_labels.ph_menu_cafe',             
        restaurant: 'settings.custom_labels.ph_menu_restaurant', 
        fastfood: 'settings.custom_labels.ph_menu_fastfood',     
        icecream: 'settings.custom_labels.ph_menu_icecream',     
        sweets: 'settings.custom_labels.ph_menu_sweets',         
        bakery: 'settings.custom_labels.ph_menu_bakery'          
      };

      const smartDefaultTitle = titleKeys[businessType] 
        ? this.$t(titleKeys[businessType]) 
        : this.$t('settings.custom_labels.ph_product_list');

      const isFoodMenu = ['cafe','restaurant','fastfood','icecream'].includes(businessType);
      const smartDefaultCartBtn = isFoodMenu 
        ? this.$t('settings.custom_labels.ph_add_order') 
        : this.$t('settings.custom_labels.ph_add_cart'); 

      let finalTitle = customLabels.productsTitle;
      if (finalTitle && (finalTitle.includes('settings.') || finalTitle.includes('ph_'))) {
        finalTitle = this.$t(finalTitle);
      }
      if (!finalTitle) {
        const oldTitle = this.value?.product?.title;
        const oldDefaults = ['محصولات', 'منوی سفارش', 'منوی رستوران', 'منوی کافه'];
        if (oldTitle && !oldDefaults.includes(oldTitle)) {
          finalTitle = oldTitle;
        } else {
          finalTitle = smartDefaultTitle;
        }
         if (oldTitle && oldTitle.includes('settings.')) {
            finalTitle = smartDefaultTitle;
        } else if (oldTitle && !oldDefaults.includes(oldTitle)) {
          finalTitle = oldTitle;
        } else {
          finalTitle = smartDefaultTitle;
        }
      }
      
      const finalCartBtn = customLabels.cartButton || smartDefaultCartBtn;

      let finalCurrency = 'ریال';
      
      if (rawSettings.currency) {
        if (typeof rawSettings.currency === 'string') {
          finalCurrency = rawSettings.currency;
        } else if (typeof rawSettings.currency === 'object') {
          finalCurrency = rawSettings.currency.text || rawSettings.currency.value || 'ریال';
        }
      }

      return {
        businessType: businessType,
        currency: finalCurrency, 
        showFilter: rawSettings.showFilter !== false,
        showCategories: rawSettings.showCategories !== false, 
        sectionTitle: finalTitle,
        cartButtonText: finalCartBtn
      };
    },

    computedBanner() {
      if (this.value?.banner?.gallery && this.value.banner.gallery[0])
        return {
          banner: this.value.banner.gallery[0]
        }
      else {
        return null
      }
    },
    hasGallery() {
      return this.value.gallery?.length > 0 && this.value.gallery?.filter(item => item.images?.length > 0)?.length > 0
    },
    hasVideo() {
      return !!this.value.VideoGallery && !!this.value.video_gallery?.filter(g => !!g.images.length)?.length
    },
    getProductList() {
      const getProductsRecursive = (item) => {
        let productsList = [];

        if (item?.children?.length) {
          item.children.forEach(child => {
            if (this.categoryFilter.sub == null || (child.id || child.slug) === this.categoryFilter.sub) {
              productsList = productsList.concat(getProductsRecursive(child));
            }
          });
        } else {
          productsList = item?.products || [];
        }

        return productsList;
      };

      if (!this.value?.product?.items) return [];

      return this.value.product.items
        .filter((item, index) => index === this.selectedCategory)
        .map(item => getProductsRecursive(item))
        .filter(list => list.length > 0)
        .flat();
    }
  },

  watch: {
    value: {
      deep: true,
      handler() {
        this.$forceUpdate()
      }
    }
  },
}
</script>

<style>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
  text-wrap: wrap;
}
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}

</style>
